import React from 'react';
import { getCalendarAppointmentEventDetail } from 'api/google'
import { Event, TServerCalendarAppointmentEventDetail } from 'types/calendar';


const useCalendarAppointmentEventDetail = (event?: Event): [TServerCalendarAppointmentEventDetail | undefined, boolean, () => void] => {
    const [loading, setLoading] = React.useState(false);
    const [data, setData] = React.useState<TServerCalendarAppointmentEventDetail>();
    const fetchData = async () => {
        if (loading || !event) return;
        try {
            setLoading(true);
            const result = await getCalendarAppointmentEventDetail(event.id + '');
            if (!result.error) {
                const resData = result?.data?.data || undefined;
                setData(resData);
            }
            // setLoading(false);
        } catch (e) {
            console.error(e);
        }
        setLoading(false);
    };
    React.useEffect(() => {
        if (event) {
            setData(undefined);
            fetchData();
        }
    }, [event]);

    return [data, loading, fetchData];
};

export default useCalendarAppointmentEventDetail;
